module.exports = __webpack_public_path__ + "media/src/assets/images/nextplay-6a10e23cfc196dd02452c14c9fa07708.svg";